import {
    ANGELIKA_CINEMAS,
    CLASS_GOLD,
    CLASS_IMAX,
    CLASS_PREMIUM,
    CLASS_PREMIUM_PLUS,
    CLASS_STANDARD,
    HOYTS_CINEMAS,
    PALACE_CINEMAS,
    READING_CINEMAS,
    VILLAGE_CINEMAS
} from "@config/config";


const EXPERIENCE_MAP = {
    STND: {
        short: "STND",
        long: "Standard",
        button: "STND",
        value: "STND",
        banner: "STND-banner.webp",
        image: "STND.webp",
        code: "STND",
        ticketClassId: CLASS_STANDARD,
    },
    PREM: {
        short: "PREM",
        long: "Premium",
        button: "PREM",
        value: "PREM",
        banner: "PREM-banner.webp",
        image: "PREM.webp",
        code: "PREM",
        ticketClassId: CLASS_PREMIUM,
    },
    "PREM+": {
        short: "PREMPLUS",
        long: "Premium Plus",
        button: "PREM+",
        value: "PREM+",
        banner: "PREM-banner.webp",
        image: "PREM.webp",
        code: "PREM+",
        ticketClassId: CLASS_PREMIUM_PLUS,
    },
    IMAX: {
        short: "IMAX",
        long: "Imax",
        button: "IMAX",
        value: "IMAX",
        banner: "PREM-banner.webp",
        image: "PREM.webp",
        code: "IMAX",
        ticketClassId: CLASS_IMAX,
    },
    GOLD: {
        short: "GOLD",
        long: "Gold",
        button: "GOLD",
        value: "GOLD",
        banner: "GOLD-banner.webp",
        image: "GOLD.webp",
        code: "GOLD",
        ticketClassId: CLASS_GOLD,
    },
};

const UNKNOWN_EXPERIENCE = {
    short: "unknown-0",
    long: "Unnamed",
    button: "UNK",
    value: "unknown-0",
    banner: "unknown-0-banner.png",
    image: "unknown-0.png",
    code: "unknown-0",
    description: "",
};

const GOLD_BY_GROUP = {
    [HOYTS_CINEMAS]: { long: "Lux", button: "LUX" },
    [READING_CINEMAS]: { long: "Gold", button: "GOLD" },
    [PALACE_CINEMAS]: { long: "Platinum", button: "PLTM" },
    [ANGELIKA_CINEMAS]: { long: "SoHo", button: "SoHo" },
};
const DEFAULT_GOLD = { long: "Gold", button: "GOLD" };

const PREMIUM_BY_GROUP = {
    [VILLAGE_CINEMAS]: { long: "VMAX", button: "VMAX" },
    [READING_CINEMAS]: { long: "Premium Standard", button: "PREM" },
    [PALACE_CINEMAS]: { long: "Deluxe", button: "DLX" },
};
const DEFAULT_PREMIUM = { long: "Premium", button: "PREM" };

const PREMIUM_PLUS_BY_GROUP = {
    [VILLAGE_CINEMAS]: { long: "VMAX Plus", button: "VMAX+" },
    [READING_CINEMAS]: { long: "TITAN LUXE", button: "TITAN LUXE" },
};
const DEFAULT_PREMIUM_PLUS = { long: "Premium Plus", button: "PREM+" };


export const getExperienceDetails = (input, options = {}) => {
    const getValue = options.get || null;
    const ticketClassId = typeof input === "number" ? input : null;
    const inputStr = typeof input === "string" ? input.trim().toUpperCase() : "";
    const sessionType = (options.sessionType || "").toLowerCase();
    const groupId = Number(options.cinemaGroupId);

    if (EXPERIENCE_MAP[inputStr]) {
        const match = EXPERIENCE_MAP[inputStr];
        return getValue ? match[getValue] : match;
    }

    if (ticketClassId !== null) {
        let short = "STND";
        let long = "Standard";
        let button = "STND";

        switch (ticketClassId) {
            case CLASS_GOLD: {
                short = "GOLD";
                ({ long, button } = GOLD_BY_GROUP[groupId] || DEFAULT_GOLD);
                break;
            }

            case CLASS_PREMIUM: {
                short = "PREM";

                if (groupId === HOYTS_CINEMAS) {
                    if (sessionType.includes("apex")) {
                        long = "APEX";
                        button = "APEX";
                    } else if (sessionType.includes("xtremescreen")) {
                        long = "Xtremescreen";
                        button = "XTRM";
                    } else if (sessionType.includes("dbox")) {
                        long = "DBox";
                        button = "DBOX";
                    } else if (sessionType.includes("screenx")) {
                        long = "ScreenX";
                        button = "SCREENX";
                    } else if (sessionType.includes("imax")) {
                        long = "IMAX";
                        button = "IMAX";
                    } else {
                        long = "Xtremescreen";
                        button = "XTRM";
                    }
                } else {
                    ({ long, button } = PREMIUM_BY_GROUP[groupId] || DEFAULT_PREMIUM);
                }
                break;
            }

            case CLASS_PREMIUM_PLUS: {
                short = "PREM+";

                if (groupId === HOYTS_CINEMAS) {
                    if (sessionType.includes("dbox")) {
                        long = "DBox Plus";
                        button = "DBOX+";
                    } else if (sessionType.includes("screenx")) {
                        long = "ScreenX Plus";
                        button = "SCREENX+";
                    } else {
                        long = "Xtremescreen Plus";
                        button = "XTRM+";
                    }
                } else {
                    ({ long, button } = PREMIUM_PLUS_BY_GROUP[groupId] || DEFAULT_PREMIUM_PLUS);
                }
                break;
            }

            case CLASS_IMAX: {
                if (groupId === HOYTS_CINEMAS) {
                    short = "IMAX";
                    long = "Imax";
                    button = "IMAX";
                }
                break;
            }

            case CLASS_STANDARD:
            default: {
                short = "STND";
                long = "Standard";
                button = "STND";

                if (groupId === VILLAGE_CINEMAS) {
                    if (sessionType.includes("vpremium")) {
                        short = "PREM";
                        long = "Vpremium";
                        button = "VPRM";
                    } else if (sessionType.includes("vjunior")) {
                        long = "Vjunior";
                        button = "VJNR";
                    }
                }
                break;
            }
        }

        if (EXPERIENCE_MAP[short]) {
            const match = { ...EXPERIENCE_MAP[short], long, button };
            return getValue ? match[getValue] : match;
        }
    }

    return UNKNOWN_EXPERIENCE;
};

const getSessionExperienceField = (session, field) =>
    getExperienceDetails(Number(session?.ticket_class_id), {
        sessionType: session?.session_type,
        cinemaGroupId: session?.cinema_group_id,
        get: field,
    });

export const getSessionButtonText = (session) => getSessionExperienceField(session, "button");

export const getSessionTextFull = (session) => getSessionExperienceField(session, "long");

export const getSessionType = (session) => getSessionExperienceField(session, "short");


export const getAllExperiences = () =>
    Object.values(EXPERIENCE_MAP).map(({ ticketClassId, code, long, image, banner }) => ({
        id: ticketClassId,
        code,
        label: long,
        image,
        banner,
    }));


export const getVoucherUpgradeDetails = (session) => {
    if (!session) return null;

    const message = session.upgrade_message ?? null;
    const fee = session.upgrade_fee ?? null;

    const hasMessage = message != null && message !== "";
    const hasFee = fee != null && fee !== 0;

    if (!hasMessage && !hasFee) {
        return null;
    }

    return {
        fee: fee ?? 0,
        message: message ?? "",
    };
};
